import React, { Component } from 'react';

export default class Icon extends Component {
  render () {
    const { className } = this.props;
    let iconClassNames = className;
    if (className.indexOf('icon icon-') === -1) {
      iconClassNames = `nc-icon-outline ${className}`;
    }
    return (
      <i className={iconClassNames} style={{ marginRight: 6, ...this.props.style }}></i>
    );
  }
}

Icon.defaultProps = {
  style: {},
};



// WEBPACK FOOTER //
// ./src/common/views/Icon.js